export const SET_STEPS_DATA = "SET_STEPS_DATA";

export const ONBOARDING_DETAILS_SAVE_REQUEST =
  "ONBOARDING_DETAILS_SAVE_REQUEST";
export const ONBOARDING_DETAILS_SAVE_SUCCESS =
  "ONBOARDING_DETAILS_SAVE_SUCCESS";
export const ONBOARDING_DETAILS_SAVE_ERROR = "ONBOARDING_DETAILS_SAVE_ERROR";

export const SIDEBAR_LIST = "SIDEBAR_LIST";

export const RESET_BLOCK_ONBOARDING = "RESET_BLOCK_ONBOARDING";
export const RESET_FLAGS_ONBOARDING = "RESET_FLAGS_ONBOARDING";

const block = {
  loading: false,
  error: "",
  success: false,
};

const initialState = {
  steps: {},
  saveOnboardingDetails: { ...block },
  sidebar: [],
};

export const OnboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIDEBAR_LIST:
      return {
        ...state,
        sidebar: action.payload,
      };

    case SET_STEPS_DATA:
      return {
        ...state,
        steps: {
          ...state.steps,
          ...action.payload,
        },
      };

    case ONBOARDING_DETAILS_SAVE_REQUEST:
      return {
        ...state,
        saveOnboardingDetails: {
          ...state.saveOnboardingDetails,
          loading: true,
          success: false,
        },
      };
    case ONBOARDING_DETAILS_SAVE_SUCCESS:
      return {
        ...state,
        saveOnboardingDetails: {
          ...state.saveOnboardingDetails,
          loading: false,
          success: true,
        },
      };
    case ONBOARDING_DETAILS_SAVE_ERROR:
      return {
        ...state,
        saveOnboardingDetails: {
          ...state.saveOnboardingDetails,
          loading: false,
          success: false,
          error: action.payload,
        },
      };

    //reset block with flag and data
    case RESET_BLOCK_ONBOARDING:
      return {
        ...state,
        [action.payload.blockType]: {
          ...state[action.payload.blockType],
          ...initialState[action.payload.blockType],
        },
      };

    //reset only flags(block)
    case RESET_FLAGS_ONBOARDING:
      return {
        ...state,
        [action.payload.blockType]: {
          ...state[action.payload.blockType],
          ...block,
        },
      };

    default:
      return state;
  }
};
